import styled from "styled-components";

export default styled.div`
  padding: 3vw 6vw 3vw 6vw;
`;
